import React from "react";
import Animation from "../../svgs/animated-logo.svg";

const AnimatedLogo = () => <Animation />;

export default AnimatedLogo;
